import * as angular from 'angular';

class NfcHistoryExportItem {
}

angular.module('naut').component('nfcHistoryExportItem', {
    template: require('./history-export-item.component.html'),
    controller: NfcHistoryExportItem,
    controllerAs: 'ctrl',
    bindings: {
        'operationId': '<',
        'status': '<',
        'items': '<',
        'date': '<',
        'exportResult': '<'
    },
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/history/history-export-item/history-export-item.component.ts